import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import {
    blockScreen,
    unblockScreen,
    activateNextButton,
    deactivateNextButton,
    greyOutScreen,
} from '../../../common/screen/screenActions';
import { narrateStart } from '../../../common/audio/audioActions';
import selectors from '../../../rootSelectors';
import {
    highlightPossibleResponse,
    selectPossibleResponse,
    makeFirstAttempt,
    activateReadyForNextScreen,
} from '../../../common/questions/questionsActions';
import { PRACTICE } from '../../../constants/assessmentItemType';
import { WR } from '../../../constants/measure';
import { goToCountdown } from '../../../common/navigation/navigationActions';
import { GENERAL_AUDIO_DELAY } from '../../../constants/time';
import WR_AUDIO_INSTRUCTIONS from '../../wrConstants';

export const handleOnNext = () => async (dispatch, getStore) => {
    const state = getStore();
    if (!selectors.getQuestionsIsReadyForNextScreen(state)) {
        dispatch(blockScreen());
        dispatch(greyOutScreen());
        dispatch(deactivateNextButton());
        await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.wrReadyInstruction));
        dispatch(setAvatarInstructions(WR_AUDIO_INSTRUCTIONS.wrReadyInstruction));
        dispatch(activateReadyForNextScreen());
        dispatch(activateNextButton());
        dispatch(unblockScreen());
    } else {
        dispatch(goToCountdown(WR.KEY));
    }
};

export const narrateScreen = (stimulusAudio, delay = GENERAL_AUDIO_DELAY) => async dispatch => {
    dispatch(blockScreen());
    dispatch(narrateStart());
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.avatarStart));
    await dispatch(playStimulusAudio([stimulusAudio], delay));
    dispatch(unblockScreen());
};

const handleCorrectResponseSelected = index => async dispatch => {
    dispatch(selectPossibleResponse(index));
    dispatch(blockScreen());
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.correctResponseInstruction));
    dispatch(setAvatarInstructions([WR_AUDIO_INSTRUCTIONS.clickOk]));
    dispatch(activateNextButton());
    dispatch(unblockScreen());
};

const handleFirstIncorrectResponseSelected = stimulusAudio => async dispatch => {
    dispatch(blockScreen());
    dispatch(makeFirstAttempt());
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.firstIncorrectInstruction));
    await dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY));
    dispatch(setAvatarInstructions(WR_AUDIO_INSTRUCTIONS.firstIncorrectInstruction));
    dispatch(unblockScreen());
};

const handleSecondIncorrectResponseSelected = correctResponseIndex => async dispatch => {
    dispatch(blockScreen());
    dispatch(highlightPossibleResponse(correctResponseIndex));
    await dispatch(playAvatarAudio(WR_AUDIO_INSTRUCTIONS.secondIncorrectInstruction));
    dispatch(setAvatarInstructions(WR_AUDIO_INSTRUCTIONS.clickOk));
    dispatch(activateNextButton());
    dispatch(unblockScreen());
};

export const selectPracticeScreenResponse = index => (dispatch, getStore) => {
    const state = getStore();
    const isFirstAttemptMade = selectors.getIsFirstAttemptMade(state);
    const correctResponseIndex = selectors.getWRCorrectResponseIndex(state, PRACTICE);
    if (correctResponseIndex !== index) {
        if (!isFirstAttemptMade) {
            const stimulusAudio = selectors.getWRStimulusAudio(state, PRACTICE);
            return dispatch(handleFirstIncorrectResponseSelected(stimulusAudio));
        }

        return dispatch(handleSecondIncorrectResponseSelected(correctResponseIndex));
    }

    return dispatch(handleCorrectResponseSelected(index));
};
